import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import "./App.css";
import { ThemedSuspense } from "components/themedSuspense";
import { ROUTE_PAGE_PUBLIC, ROUTE_PAGE_PRIVATE, ROUTE_PAGE_PERMISSION } from "routes";
import PATHS from "routes/path";
import { redirectLogin } from "helper/authRedirect";

// giả lập check login (sau này thay bằng context hoặc hook useAuth)
const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

// Component bọc route private
const PrivateRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) {
        redirectLogin();   // 🔥 redirect theo SSO / LOGIN mode
        return null;       // không render gì cả
      }
      return <Component {...props} />;
    }}
  />
);

// Component bọc route permission
// Giả sử BE trả về danh sách quyền của user
const PermissionRoute = ({ component: Component, requiredKey, ...rest }: any) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={PATHS.PORTAL} />
      )
    }
  />
);

const App = (): JSX.Element => {
  return (
    <Suspense fallback={<ThemedSuspense />}>
      <Router>
        <Switch>
          {/* Public routes */}
          {ROUTE_PAGE_PUBLIC.map((route) => (
            <Route
              key={route.key}
              path={route.path}
              component={route.component}
              exact
            />
          ))}

          {/* Private routes */}
          {ROUTE_PAGE_PRIVATE.map((route) => (
            <PrivateRoute
              key={route.key}
              path={route.path}
              component={route.component}
              exact
            />
          ))}

          {/* Permission routes */}
          {ROUTE_PAGE_PERMISSION.map((route) => (
            <PermissionRoute
              key={route.key}
              path={route.path}
              component={route.component}
              requiredKey={route.key} // check dựa trên key = permission
              exact
            />
          ))}

          <Redirect to={PATHS.NOT_FOUND} />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default App;
